<mds-dialog dialogTitle="Cannot Complete Request">
    <mds-dialog-content>
        <p>
            Request cannot be completed because the patient is not ready for payment. Make sure proper forms have been
            uploaded to Patient Profile
        </p>
    </mds-dialog-content>
    <mds-dialog-actions>
        <mds-button
            [id]="'medpaceBtn'"
            label="Okay"
            (clickEvent)="closeDialog()"
            [color]="'primary'"
            [variant]="'filled'"
        ></mds-button>
    </mds-dialog-actions>
</mds-dialog>
